// extracted by mini-css-extract-plugin
export default {"claimSummaryTable":"ClaimSummary_claimSummaryTable__9Ew0Y","upArrow":"ClaimSummary_upArrow__3D0HF","downArrow":"ClaimSummary_downArrow__8JbYk"};